export default "__VITE_ASSET__DRyGBBwI__"